<template>
	<div>
		<checkbox
			:checkbox="{
				txt: label,
				isChecked: value
			}"
			@click.native="$emit('input', !value)"
			:class="{'is-invalid': error}"
		></checkbox>
		<span
			:class="[
				'styled-form__error',
				'styled-form__error--checkbox',
				{'is-visible': error}
			]"
		>{{ error }}</span>
	</div>
</template>

<script>
	import Checkbox from './Checkbox.vue';

	export default {
		components: {
			Checkbox
		},
		model: {
			prop: 'value'
		},
		props: {
			label: String,
			error: String,
			value: Boolean
		}
	};
</script>